<template>
  <div class="videolibrary container-fluid">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">Video Library</h4>
              </div>
            </div>
          </div>
          <b-card no-body id="videoLibraryCard" class="p-3">
            <b-card-header class="pb-0">
              <div class="row">
                <div class="col-12 mb-2 mb-md-0">
                  <div class="btn-group">
                    <button type="button" class="
                        btn
                        btn-bumblebee
                        btn-doomyoga
                        btn-tab
                        btn-doomyoga-secondary
                        active
                      ">
                      On Demand Videos
                    </button>
                  </div>
                </div>
              </div>
            </b-card-header>
            <b-card-body class="p-md-3 pt-md-0 p-0 pt-3">
              <MediaLibraryCategoryList :client_name="client_name" :media_library="media_library"
                :search_input_class="'input-group-search-doomyoga'"
                  :project_btn_class="'btn-doomyoga'"
                :input_class="'form-control-doomyoga'"
                :btn_size_class="'btn-lg-doomyoga'" 
                :btn_variant_primary="'doomyoga-primary'"
                :btn_variant_info="'doomyoga-info'"
                :btn_variant_delete="'doomyoga-info'"
                :category_tracks_url="'/doom_yoga/video_library/category/'"
                :btn_group_actions_class="'btn-group-actions-doomyoga'"
                :dataset_not_found_data_class="'noDataFoundDY'"
                :dataset_data_info_class="'datasetInfoDY'"
                :dataset_pagination_class="'datasetPagerDY'"

                :modal_class="'modal-doom-yoga'"
                :confirm_message_class="'message-modal-dy'"
                :btn_submit_class="'btn-doomyoga btn-doom-yoga-submit'"
                :btn_danger_outline_class="'doomyoga-danger-outline'"

                :form_label_class="'form-label-doomyoga'"
                :error_validation_msg_class="'error_validation_message_p_dy'"
                :video_preview_container_class="'video-preview-container-doomyoga'"
                :add_video_btn_outline_variant="'doomyoga-danger-outline'"
                :progress_bar_class="'progress-bar-doom-yoga'"
                :vselect_class="'form-group-vselect-doomyoga'"

                :media_gallery_class="'media-gallery-dy'"
                :card_no_found_media_class="'card-no-found-media-dy'"
                :no_found_media_text_class="'no-media-text-dy'"
                :media_card_class="'media-card-dy'"
                
                :swal_confirm_button_class="'btn btn-bumblebee btn-doomyoga  btn-doomyoga-primary'"
            :swal_container_class="'swal-container-doom-yoga'"

                />

            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

import MediaLibraryCategoryList from '@/components/media_components/library/CategoryList.vue'

export default {
  name: "VideoLibrary",
  components: {
    MediaLibraryCategoryList
  },
  data() {
    return {
      client_name: "DY",
      media_library: "video_library",
    };
  },
  mounted() {
  },
  computed: {},
  created() {
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/video_library/CategoryList.vue